import { createStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import CustomStepperTrackingChild from './CustomStepperTrackingChild/CustomStepperTrackingChild';
import useStyles from './CustomStepperTrackingStyles';
var CustomStepperTracking = function (_a) {
    var className = _a.className, dataTestId = _a.dataTestId, modeloPasos = _a.modeloPasos;
    var styles = useStyles();
    var _b = useState(''), ocultarChild = _b[0], setOcultarChild = _b[1];
    var _c = useState(0), indexActivo = _c[0], setIndexActivo = _c[1];
    var obtenerColorPaso = function (colorPaso) {
        switch (colorPaso) {
            case 'verdeClaro':
                return styles.verdeClaro;
            case 'verdeOscuro':
                return styles.verdeOscuro;
            case 'rojo':
                return styles.rojo;
            case 'amarillo':
                return styles.amarillo;
            case 'grisL93':
                return styles.grisL93;
            case 'grisL83':
                return styles.grisL83;
            default:
                return styles.grisL63;
        }
    };
    var obtenerOcultarChild = function () {
        var stylesOcultar = styles.ocultarUltimo;
        modeloPasos.forEach(function (modeloStep, index) {
            var _a, _b;
            if (!((_a = modeloStep === null || modeloStep === void 0 ? void 0 : modeloStep.colorTitulo) === null || _a === void 0 ? void 0 : _a.includes('gris')) && index > 1) {
                stylesOcultar = styles.ocultarPrimero;
                setIndexActivo(index);
                return stylesOcultar;
            }
            if (!((_b = modeloStep === null || modeloStep === void 0 ? void 0 : modeloStep.colorTitulo) === null || _b === void 0 ? void 0 : _b.includes('gris')) && index <= 1) {
                stylesOcultar = styles.ocultarUltimo;
                setIndexActivo(index);
                return stylesOcultar;
            }
            return stylesOcultar;
        });
        return stylesOcultar;
    };
    var obtenerColorLinea = function (colorLinea) {
        switch (colorLinea) {
            case 'verdeClaro':
                return 'var(--verde-exito)';
            case 'verdeOscuro':
                return 'var(--verde-l33)';
            case 'rojo':
                return 'var(--rojo-error)';
            case 'amarillo':
                return 'var(--amarillo-l44)';
            case 'grisL93':
                return 'var(--gris-l93)';
            case 'grisL83':
                return 'var(--gris-l83)';
            case 'grisL63':
                return 'var(--gris-l63)';
            case 'grisL43':
                return 'var(--gris-l43)';
            default:
                return 'var(--gris-l93)';
        }
    };
    var customUseStyles = makeStyles(function (theme) {
        var _a, _b;
        return createStyles({
            transparenciaPrimero: (_a = {},
                _a[theme.breakpoints.down('sm')] = {
                    '&:nth-last-child(3)': {
                        background: "linear-gradient(to top, " + obtenerColorLinea(modeloPasos[1] ? modeloPasos[1].colorPaso : undefined) + " 0%, var(--blanco) 100%)",
                    },
                },
                _a),
            transparenciaUltimo: (_b = {},
                _b[theme.breakpoints.down('sm')] = {
                    '&:nth-last-child(2)': {
                        background: "linear-gradient(to bottom, " + obtenerColorLinea(modeloPasos[3] ? modeloPasos[3].colorPaso : undefined) + " 0%, var(--blanco) 100%)",
                    },
                },
                _b),
        });
    });
    var customStyles = customUseStyles();
    useEffect(function () {
        setOcultarChild(obtenerOcultarChild());
    }, []);
    return (React.createElement("section", { className: className + " " + styles.principal }, modeloPasos.map(function (modeloStep) {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomStepperTrackingChild, { key: dataTestId, className: clsx(styles.circulo + " " + obtenerColorPaso(modeloStep.colorPaso) + " " + ocultarChild, (_a = {},
                    _a[customStyles.transparenciaPrimero] = indexActivo > 1,
                    _a[customStyles.transparenciaUltimo] = indexActivo <= 1,
                    _a)), customStepperTrackingProps: modeloStep })));
    })));
};
CustomStepperTracking.defaultProps = {
    className: '',
    dataTestId: '',
};
export default CustomStepperTracking;
